import { AutogenLayoutUnassignEquipmentPrompt } from "./autogen/AutogenLayoutUnassignEquipmentPrompt";

export class UnassignEquipmentPrompt extends AutogenLayoutUnassignEquipmentPrompt {
}
